export function MarketAvatar({ imageUrl, title, size = "md", priority = false }) {
  if (!imageUrl) {
    return null;
  }

  const sizeClass = size === "sm" ? "h-8 w-8" : "h-10 w-10";
  const pixelSize = size === "sm" ? 32 : 40;
  return (
    <img
      src={imageUrl}
      alt={`${title} market image`}
      width={pixelSize}
      height={pixelSize}
      className={`${sizeClass} shrink-0 rounded-full border border-zinc-800 object-cover`}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
    />
  );
}
